import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import type { GetSupersedeOfferData, SupersedeOfferData } from '../types';

const GET_GS_DECISION = gql`
  query ($applicationId: String!) {
    gsDecision(applicationId: $applicationId) {
      applicationId

      fileChecks {
        file {
          id
          link
          name
        }
        checked
      }
      supersededFile {
        file {
          id
          link
          name
        }
        checked
      }
    }
    programmeChoiceMetadata {
      entryYearList {
        value
        label
      }
    }
  }
`;

export const useGetSupersedeData = (
  applicationId: string,
): GetSupersedeOfferData => {
  const { data, loading, error, refetch } = useQuery(GET_GS_DECISION, {
    variables: { applicationId },
    fetchPolicy: 'network-only',
  });

  let supersedeData: SupersedeOfferData | null = null;

  if (!loading && !error) {
    const gsDecision = data?.gsDecision;
    const programmeChoiceMetadata = data?.programmeChoiceMetadata;

    if (gsDecision && programmeChoiceMetadata) {
      supersedeData = {
        applicationId: gsDecision.applicationId,
        fileChecks: gsDecision.fileChecks,
        supersededFile: gsDecision.supersededFile,
        entryYearList: programmeChoiceMetadata?.entryYearList,
      };
    }
  }

  return {
    supersedeData,
    loading,
    error,
    refetch,
  };
};
